import React, { useState, useEffect } from "react";
import { getYoutubeId } from "../../Utils/utils";
const YoutubeInput = ({ onChangeContent, currentUrl }) => {
  const [video_url, setVideoURL] = useState("");
  useEffect(() => {
    if (video_url) onChangeContent(video_url);
  }, [video_url]);
  useEffect(() => {
    if (currentUrl) {
      setVideoURL(currentUrl);
    }
  }, [currentUrl]);
  const onChangeHandler = (e) => {
    setVideoURL(e.target.value);
  };
  return (
    <React.Fragment>
      <div className="col-12 w-100">
        <input
          className="form-control"
          name="video"
          value={video_url}
          placeholder={`Input youtube video url`}
          onChange={onChangeHandler}
        ></input>
        {video_url && getYoutubeId(video_url) && (
          <div className="mt-3">
            <iframe
              title="video"
              width="100%"
              height="315"
              src={`//www.youtube.com/embed/${getYoutubeId(
                video_url
              )}?modestbranding=1&showinfo=0`}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default YoutubeInput;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/YoutubeInput.js